/**
 * /tenants/$slug/authentication/sign-in/phone — Phone & remote.
 */

import { createFileRoute } from "@tanstack/react-router";
import { signInPolicyQueryOptions } from "@/features/signin-policy/queries";
import { PhoneSection } from "@/features/signin-settings/pages/phone-section";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in/phone")({
  loader: ({ context }) => context.queryClient.prefetchQuery(signInPolicyQueryOptions(context.tenant.id)),
  component: PhoneSection,
});
